$(document).ready(function() {
	$('.section-nav-title').click(function(){
		$(this).siblings('.section-nav-list').toggleClass('is-open');
	});
});